import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Table, Spin, Button, Modal, Tooltip } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons"; // Icons from Ant Design
import TypeCreationForm from "../../Forms/TypeCreationForm/TypeCreationForm"
const TypeTable = ({
  history,
  loading,
  data,
  callReFetch,
  dispatch,
  userData,
  handleDelete,
}) => {
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [selectedType, setSelectedType] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);

  // Update isMobileView based on window type
  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleOpenEditModal = async (id) => {
    const typeToEdit = data.find((type) => type._id === id);
    if (typeToEdit) {
      setSelectedType(typeToEdit);
      setIsEditModalVisible(true);
    }
  };

  const handleCloseEditModal = () => {
    setIsEditModalVisible(false);
    setSelectedType(null);
  };

  const isAdmin = userData?.roles?.includes("admin");
  const renderActionButton = (id) => {
    if (!isAdmin) return null;
    return (<>
      {isMobileView ? (
        // Use icons on mobile view
        <>
          <Tooltip title="Edit">
            <Button
              icon={<EditOutlined />}
              onClick={() => handleOpenEditModal(id)}
              type="small"
              shape="circle"
              style={{ marginRight: 8 }}
            />
          </Tooltip>
          <Tooltip title="Delete">
            <Button
              icon={<DeleteOutlined />}
              onClick={() => handleDelete(id)}
              type="small"
              shape="circle"
              danger
            />
          </Tooltip>
        </>
      ) : (
        // Use buttons on desktop view
        <>
          <Button
            onClick={() => handleOpenEditModal(id)}
            style={{ marginRight: 8 }}
          >
            Edit
          </Button>
          <Button onClick={() => handleDelete(id)} danger>
            Delete
          </Button>
        </>
      )}
    </>
  );
};

  const handleTableOnChange = (pagination, filteredInfo, sorter) => {
    dispatch({ type: "sorter", payload: sorter });
    dispatch({ type: "filteredInfo", payload: filteredInfo });
    callReFetch();
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: true,
    },
    {
      title: "Action",
      render: (item) => renderActionButton(item._id),
      width: 400,
    },
  ];

  return (
    <>
      <div style={{width: "50vw"}}>
        <Spin spinning={loading}>
          {data && (
            <Table
              columns={columns}
              dataSource={data}
              onChange={(pagination, filteredInfo, sorter) =>
                handleTableOnChange(pagination, filteredInfo, sorter)
              }
            />
          )}
        </Spin>
        <Modal
          title="Edit Type"
          open={isEditModalVisible}
          footer={null}
          onCancel={handleCloseEditModal}
        >
          <TypeCreationForm
            history={history}
            isEditMode
            callReFetch={callReFetch}
            data={selectedType}
            onClose={handleCloseEditModal}
          />
        </Modal>
      </div>
    </>
  );
};

TypeTable.propTypes = {
};

export default TypeTable;
